
import { useAuthStore } from 'src/store/auth';
import { utils } from 'src/utils';

const publicPages = ['/', 'index', 'error',]; //public pages which do not need authentation

const roleAbilities = {
	"admin": [],
	"user": []
};

export function useAuth() {
	const store = useAuthStore();

	const user = store.state.user;
	const userRole = store.state.userRole;

	let isLoggedIn = false;
	let userName = '';
	let userEmail = '';
	let userId = '';
	let userPhoto = '';
	let userPhone = '';
	let userFullName = '';
	let userCanRegister = '';
	let usereducationalLevel = '';
	let userlearningInstitution = '';
	let usermatriculationOath = '';
	let userStatus = '';

	setUserData();

	function setUserData() {
		if (user) {
			isLoggedIn = true;
			userName = user.username;
			userId = user.student_id;
			userEmail = user.email;
			if (user.othernames != null) {
				userFullName = user.title + ' ' + user.lastname + ', ' + user.firstname + ' ' + user.othernames;
			} else {
				userFullName = user.title + ' ' + user.lastname + ', ' + user.firstname
			}
			userCanRegister = user.can_register;

			usereducationalLevel = user.educational_level
			userlearningInstitution = user.learning_institution
			usermatriculationOath = user.matriculation_oath;
			userStatus = user.status;
		}
	}

	function canRegister() {
		// Temporarily disabled - reuse in October.
		// if (userCanRegister == 'Yes') {
		// 	return true;
		// } else {
		// 	return false
		// }
		return true;
	}


	async function getUserData() {
		const token = store.getLoginToken();
		//Token is available, user might still be logged in
		if (token) {
			try {
				//fetch user data for the first time and saves in the store
				await store.getUserData();
			}
			catch (e) {
				store.logout(); //token must have expired
			}
		}
		return {
			user: store.state.user,
			userRole: store.state.userRole,
			userPages: store.state.userPages
		};
	}

	function login(payload) {
		return store.login(payload);
	}

	function saveLoginData(loginData, rememberUser) {
		const payload = { loginData, rememberUser };
		store.saveLoginData(payload);
	}

	function logout() {
		store.logout();
	}

	const pageRequiredAuth = function (path) {
		const { pageName, routePath } = utils.parseRoutePath(path);
		return !publicPages.includes(pageName) && !publicPages.includes(routePath);
	}

	const canView = function (path) {
		if (path) {
			let { routePath } = utils.parseRoutePath(path);
			const userPages = store.state.userPages;
			return publicPages.includes(routePath) || userPages.includes(routePath);
		}
		return true;
	}

	const canManage = function (page, userRecId) {
		if (userRole) {
			let userRoleAbilities = roleAbilities[userRole.toLowerCase()] || [];
			if (userRoleAbilities.includes(page)) {
				return true;
			}
		}
		return userRecId == userId;
	}

	function isOwner(userRecId) {
		if (user) {
			return userRecId == userId;
		}
		return false;
	}



	return {
		store,
		isLoggedIn,
		user,
		userName,
		userFullName,
		userId,
		userEmail,
		userPhone,
		userPhoto,
		userRole,
		getUserData,
		login,
		logout,
		saveLoginData,
		pageRequiredAuth,
		canView,
		canManage,
		isOwner,
		canRegister,
		usereducationalLevel,
		userlearningInstitution,
		usermatriculationOath,
		userStatus,
	}
}
